"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultConnectionEvents = void 0;
exports.DefaultConnectionEvents = [
    "initialized",
    "connecting",
    "connected",
    "disconnected",
    "suspended",
    "closing",
    "closed",
    "failed",
    "update",
];
